export default {
  subscribe: "Abonnieren",
  subscribeText:
    "Bleiben Sie auf dem Laufenden über die neuesten Kurse und Angebote von SkillSynergy.",
  submit: "Senden",
  sending: "Wird gesendet...",
  success: "Abonniert!",
  failed: "Fehlgeschlagen!",
};
